module.exports = __webpack_public_path__ + "img/headPortrait.bd89eb17.jpg";